import { css } from "styled-components"
import { toRem, breakpoints } from "utils/mixins"

import { fontBody, fontDisplay } from "./fonts"

export const h1 = css`
  font-family: ${fontDisplay};
  font-weight: 400;
  font-size: ${toRem(44)};
  line-height: 1.05;
  margin: 0;
  margin-bottom: ${toRem(20)};
  letter-spacing: -0.5px;

  @media ${breakpoints.tablet} {
    font-size: ${toRem(64)};
  }

  @media ${breakpoints.laptop} {
    font-size: ${toRem(80)};
    letter-spacing: -1px;
  }
`

export const h2 = css`
  font-family: ${fontBody};
  font-weight: 600;
  font-size: ${toRem(34)};
  line-height: 1.1;
  letter-spacing: -0.3px;
  margin-bottom: ${toRem(16)};

  @media ${breakpoints.tablet} {
    font-size: ${toRem(48)};
  }

  @media ${breakpoints.laptop} {
    font-size: ${toRem(60)};
    letter-spacing: -0.5px;
  }
`

export const h3 = css`
  font-family: ${fontBody};
  font-weight: 500;
  font-size: ${toRem(22)};
  line-height: 1.4;
  letter-spacing: 0;

  @media ${breakpoints.laptop} {
    font-size: ${toRem(28)};
  }
`

export const h4 = css`
  font-family: ${fontBody};
  font-size: ${toRem(17)};
  line-height: ${toRem(24)};
  letter-spacing: 0;
  font-weight: 500;
`

export const h5 = css`
  font-family: ${fontBody};
  font-size: ${toRem(12)};
  line-height: ${toRem(16)};
  letter-spacing: 1.5px;
  text-transform: uppercase;
  font-weight: 500;
`

export const p = css`
  font-family: ${fontBody};
  font-size: ${toRem(17)};
  line-height: 1.65;
  font-weight: 400;
`

export const kicker = css`
  font-family: ${fontBody};
  font-size: ${toRem(12)};
  line-height: ${toRem(16)};
  font-weight: 500;
  letter-spacing: 1.5px;
  text-transform: uppercase;
`
